import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

interface SidebarItemProps {
    to: string
    icon: IconDefinition
    label: string
    active: boolean
}

const SidebarItem: React.FC<SidebarItemProps> = ({
    to,
    icon,
    label,
    active,
}) => {
    return (
        <li>
            <Link
                to={to}
                className={`flex transition-colors duration-300 ease-in-out p-2 rounded-lg ${
                    active
                        ? ' text-ctxt-blue bg-ctxt-blue bg-opacity-10'
                        : ' text-gray-700 hover:text-ctxt-blue'
                }`}
            >
                <div className="flex items-center">
                    <FontAwesomeIcon icon={icon} className="text-[1.2rem]" />
                    <span className="ml-2">{label}</span>
                </div>
            </Link>
        </li>
    )
}

export default SidebarItem
